import { render, staticRenderFns } from "./banner_logo_wb4a.vue?vue&type=template&id=439d51a8&scoped=true&"
import script from "./banner_logo_wb4a.vue?vue&type=script&lang=js&"
export * from "./banner_logo_wb4a.vue?vue&type=script&lang=js&"
import style0 from "./banner_logo_wb4a.vue?vue&type=style&index=0&id=439d51a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439d51a8",
  null
  
)

export default component.exports